var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ResourceCards",
    {
      attrs: {
        disabled: _vm.isCardDisabled,
        footerPadding: "px-0",
        cardClass: "h-fit fullWidthCardRes",
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "flex gap-1 w-full skills-footer items-center cardBorder px-4",
                  class: !_vm.getRoleAdmin && `mt-4`,
                },
                [
                  _vm._v(" Skills: "),
                  _vm.skills.length > 0
                    ? _c(
                        "div",
                        { staticClass: "flex flex-row gap-1 items-center" },
                        [
                          _vm._l(_vm.skills.slice(0, 3), function (skill) {
                            return _c(
                              "div",
                              {
                                key: skill.skill.name,
                                staticClass: "skills-chip",
                              },
                              [_vm._v(" " + _vm._s(skill.skill.name) + " ")]
                            )
                          }),
                          _vm.skills.length > 3
                            ? _c("div", [
                                _c("div", { staticClass: "skills-chip-plus" }, [
                                  _vm._v(
                                    " +" + _vm._s(_vm.skills.length - 3) + " "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.skills.length === 0
                    ? _c("div", [_vm._v("n/a")])
                    : _vm._e(),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col w-full p-4 pb-0" },
        [
          _c("div", { staticClass: "flex flex-row justify-between pb-2" }, [
            _c(
              "div",
              { staticClass: "flex flex-col gap-2" },
              [
                !_vm.isManagerSuspended && !_vm.isEmailUnconfirmed
                  ? _c("Badge", {
                      staticClass: "text-badge capitalize",
                      attrs: {
                        color: _vm.BadgeColor.ACTIVE,
                        styleClasses: "py-0.5 px-2",
                        value: "Active",
                      },
                    })
                  : _vm._e(),
                _vm.isManagerSuspended
                  ? _c("Badge", {
                      attrs: {
                        color: _vm.BadgeColor.WARNING,
                        styleClasses: "py-0.5 px-2",
                        value: _vm.managerSuspendedText,
                      },
                    })
                  : _vm._e(),
                _vm.isEmailUnconfirmed && !_vm.isManagerSuspended
                  ? _c("Badge", {
                      attrs: {
                        color: _vm.BadgeColor.WARNING,
                        styleClasses: "py-0.5 px-2",
                        value: _vm.emailStatusText,
                      },
                    })
                  : _vm._e(),
                _c("span", { staticClass: "hidden" }, [_vm._v("space")]),
              ],
              1
            ),
            _c("div", { staticClass: "flex flex-row gap-2" }, [
              !_vm.isCardDisabled
                ? _c(
                    "button",
                    {
                      on: {
                        mouseover: function ($event) {
                          _vm.isHovered = true
                        },
                        mouseout: function ($event) {
                          _vm.isHovered = false
                        },
                        click: function ($event) {
                          return _vm.$emit("message", _vm.manager)
                        },
                      },
                    },
                    [
                      !_vm.isHovered
                        ? _c("ChatIcon", { staticClass: "h-4 w-4" })
                        : _vm._e(),
                      _vm.isHovered
                        ? _c("ChatIconHover", { staticClass: "h-4 w-4" })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "flex w-full justify-center h-fit" },
            [
              _c(
                "RouterLink",
                { attrs: { to: _vm.managerLink } },
                [
                  _c("ResourceAvatar", {
                    staticClass: "cursor-pointer text-primary-600",
                    attrs: {
                      image: _vm.managerAvatar,
                      initial: _vm.managerInitials,
                      disabled: _vm.isCardDisabled,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex items-center justify-center pt-2" },
            [
              _c(
                "RouterLink",
                { staticClass: "mr-[40px]", attrs: { to: _vm.managerLink } },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "font-medium text-lg mb-1 blueText text-default-500 hover:text-primary-500 flex flex-row items-center cursor-pointer gap-2 whitespace-nowrap text-center minHeightTitle",
                    },
                    [
                      _c("div", [
                        _vm._v(" " + _vm._s(_vm.managerFullName) + " "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flag-wrapper" },
                        [
                          _vm.country
                            ? _c("country-flag", {
                                staticClass: "country-flag",
                                attrs: { country: _vm.country, size: "small" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "flex justify-center text-default-500 text-base font-normal minHeightTitle text-center",
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.managerJobTitle ? _vm.managerJobTitle : "n/a") +
                  " "
              ),
            ]
          ),
          _vm.managerLocation
            ? _c(
                "div",
                {
                  staticClass:
                    "flex justify-center text-default-grey text-sm font-medium mb-1.5 minHeightTitle text-center",
                },
                [_vm._v(" " + _vm._s(_vm.managerLocation) + " ")]
              )
            : _vm._e(),
          _vm.getRoleAdmin
            ? _c("ActionSection", {
                attrs: {
                  actionObject: _vm.getActionSectionValues,
                  currentUser: _vm.currentUser,
                  manager: _vm.manager,
                  onActivateManager: _vm.onActivateManager,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }